import React from "react";
import CollectionIcon from "./collection-icon.jsx";

const IconPreviews = ({ icons }) =>
    icons.map(icon => (
        <CollectionIcon
            key={icon.id}
            icon={icon}
            iconPreview="preview_url_84"
        />
    ));

const Collection = ({ collection }) => (
    <div>
        <header data-collection-id={collection.id}>
            <h3>
                <a href={collection.permalink}>{collection.name}</a>
            </h3>
            <p>
                <a href={collection.author.permalink}>
                    {collection.author.fullName}
                </a>
                <a className="view-all" href={collection.permalink}>
                    View Icon Set
                </a>
            </p>
        </header>
        <ul className="results">
            <IconPreviews icons={collection.collectionIcons.icons} />
        </ul>
        <button
            type="button"
            data-action="share"
            className="share share-collection ui_share"
            data-url={collection.permalink}
            data-media=""
            data-description={`${collection.name} collection by ${collection.author.fullName}`}
        />
    </div>
);

export default Collection;
